import { useState } from 'react';

// Custom hook for localStorage persistence
const useColumnOrder = (key: string, defaultOrder: string[]) => {
  const [columnOrder, setColumnOrderState] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved ? JSON.parse(saved) : defaultOrder;
    } catch (error) {
      console.warn('Failed to load column order from localStorage:', error);
      return defaultOrder;
    }
  });

  const updateColumnOrder = (newOrder: string[]) => {
    setColumnOrderState(newOrder);
    try {
      localStorage.setItem(key, JSON.stringify(newOrder));
    } catch (error) {
      console.warn('Failed to save column order to localStorage:', error);
    }
  };

  return [columnOrder, updateColumnOrder] as const;
};

export default useColumnOrder;
